export enum EmailTemplateType {
    PasswordResetMail = 1,
    Registration = 2,
    WelcomeEmailWithSetPassword = 3,
}